export class ShowdownConfig {
  flavor = 'vanilla';
  headerLinks? = false;
}

export class Revision{
  revision: number;
  content: string;
}